export function trackMeta(eventName, params = {}) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", eventName, params);
  }
}

export function trackLead(source = "landing_cta") {
  trackMeta("Lead", { source });
}
